export default "__VITE_ASSET__950925ec__"